// AuthContext.js
import React, { createContext, useContext, useState, useEffect } from "react";
import { Get } from "../api/BaseApi";
import { errorMessage } from "../utils/alert";

import { PATH_BASE } from "../router/path";
import Swal from "sweetalert2";
import { useApi } from "../hooks/useApi";
import { handleApiError } from "../utils/ErrHandler";
// ایجاد Context برای دسترسی
const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [healthCenterId, setHealthCenterId] = useState(null); // ID کاربر
  const [healthCenterType, setHealthCenterType] = useState(null); // TYPE کاربر
  const [loading, setLoading] = useState(true);
  const [returnPATH, setReturnPATH] = useState("");

  const { data } = useApi(
    `/Common/UserPermission/${healthCenterType}/${healthCenterId}`,
    {},
    {
      method: "get",
      enabled: !!healthCenterType && !!healthCenterId,
      queryKey: [healthCenterType, healthCenterId],
      onSuccess: (res) => {},
      onError: (err) => {
        Swal.fire({
          title: "خطا",
          text: "در حال حاظر سطح دسترسی برای شما تعریف نشده",
          icon: "error",
          showCancelButton: false,
          confirmButtonColor: "#3085d6",
          allowOutsideClick: false, // جلوگیری از بسته شدن با کلیک خارج از کادر
          allowEscapeKey: false, // جلوگیری از بسته شدن با کلید Esc
          confirmButtonText: "متوجه شدم",
        }).then(async (result) => {
          if (result.isConfirmed) {
            window.location = returnPATH;
          }
        });

        errorMessage(handleApiError(err));
      },
    }
  );

  // دریافت پرمیژن‌ها از سرور
  // useEffect(() => {
  //   const fetchPermissions = async () => {
  //     // ارسال ID و TYPE به سرور
  //     const response = await Get(
  //       `/Common/UserPermission/${healthCenterType}/${healthCenterId}`
  //     )
  //       .then((res) => {
  //         const data = res.data.data.permissions;
  //         if (res.data.data.permissions.length > 0) {
  //           setPermissions(data);
  //         } else {
  //           Swal.fire({
  //             title: "خطا",
  //             text: "در حال حاظر سطح دسترسی برای شما تعریف نشده",
  //             icon: "error",
  //             showCancelButton: false,
  //             confirmButtonColor: "#3085d6",
  //             allowOutsideClick: false, // جلوگیری از بسته شدن با کلیک خارج از کادر
  //             allowEscapeKey: false, // جلوگیری از بسته شدن با کلید Esc
  //             confirmButtonText: "متوجه شدم",
  //           }).then(async (result) => {
  //             if (result.isConfirmed) {
  //               window.location = returnPATH;
  //             }
  //           });
  //         }
  //         // ذخیره پرمیژن‌ها
  //       })
  //       .catch((error) => {
  //         // پردازش خطا
  //         if (error.response) {
  //           var err = error.response.data;
  //           // اگر پاسخی از سمت سرور آمد، می‌توانید بازخورد سرور را بررسی کنید

  //           Swal.fire({
  //             title: "خطا",
  //             text: "در حال حاظر سطح دسترسی برای شما تعریف نشده",
  //             icon: "error",
  //             showCancelButton: false,
  //             confirmButtonColor: "#3085d6",
  //             allowOutsideClick: false, // جلوگیری از بسته شدن با کلیک خارج از کادر
  //             allowEscapeKey: false, // جلوگیری از بسته شدن با کلید Esc
  //             confirmButtonText: "متوجه شدم",
  //           }).then(async (result) => {
  //             if (result.isConfirmed) {
  //               window.location = returnPATH;
  //             }
  //           });

  //           //setLoading(false);
  //         } else if (error.request) {
  //           // اگر درخواستی برای سرور ارسال شده بود ولی پاسخی دریافت نشد
  //           errorMessage(error.request.message);
  //           //setLoading(false);
  //         } else {
  //           // مشکلی در هنگام پردازش درخواست پیش آمد
  //           errorMessage("مشکلی در هنگام پردازش درخواست پیش آمد");
  //           // setLoading(false);
  //         }
  //       });

  //     setLoading(false);
  //   };

  //   if (healthCenterId && healthCenterType) {
  //     fetchPermissions(); // فقط زمانی که userId و userType مشخص هستند
  //   }
  // }, [healthCenterId, healthCenterType]);

  const hasPermission = (permissionKey) =>
    data?.data?.permissions?.includes(permissionKey);
  const permissions = data?.data?.permissions;
  if (permissions?.length <= 0) {
    Swal.fire({
      title: "خطا",
      text: "در حال حاظر سطح دسترسی برای شما تعریف نشده",
      icon: "error",
      showCancelButton: false,
      confirmButtonColor: "#3085d6",
      allowOutsideClick: false, // جلوگیری از بسته شدن با کلیک خارج از کادر
      allowEscapeKey: false, // جلوگیری از بسته شدن با کلید Esc
      confirmButtonText: "متوجه شدم",
    }).then(async (result) => {
      if (result.isConfirmed) {
        window.location = returnPATH;
      }
    });
  }
  return (
    <AuthContext.Provider
      value={{
        permissions,

        healthCenterId,
        setHealthCenterId,
        healthCenterType,
        setHealthCenterType,
        loading,
        hasPermission,
        returnPATH,
        setReturnPATH,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
